// we need to remove this once tested
export const BASELINE_UPDATE_STATUS_CODE = {
  0: 'Not Commission',
  1: 'Not Detected',
  2: 'Not at Baseline',
  3: 'BaseLining Disabled',
  10: 'At Baseline',
  11: 'Baseline Error'
};
// Int type is now change to string for update baseline status code
export const BASELINE_UPDATE_STATUS_LABELS = {
  notDetected: 'Not Detected',
  baseliningInProg: 'In Progress',
  atBaseline: 'At Baseline',
  notAtBaseline: 'Not at Baseline',
  baseliningDisabled: 'Baselining Disabled',
  baselineError: 'Baseline Error',
};

export const getBaselineStatus = (updateStatusCode) => {
  if (typeof updateStatusCode === 'number' && Number.isFinite(updateStatusCode)) {
    return updateStatusCode === null || updateStatusCode === undefined
      ? ''
      : updateStatusCode >= 11
      ? BASELINE_UPDATE_STATUS_CODE['11']
      : BASELINE_UPDATE_STATUS_CODE[updateStatusCode];
  }
  if (typeof updateStatusCode === 'string') {
    return BASELINE_UPDATE_STATUS_LABELS[updateStatusCode] || 'Unknown';
  }
  return 'Unknown';
};

export function getBaselineOperationalProgress(baselineInfo = {}, isV3OrHigher = false) {
  if (!baselineInfo) return 0;
  
  const progress = baselineInfo['update-progress'];
  const code = baselineInfo['update-status-code'];

  // For v3+ API version, use enhanced parsing logic
  if (isV3OrHigher) {
    // Check if code is the string key "baseliningInProg" or if progress is available
    if (code === 'baseliningInProg' || (progress !== undefined && progress !== null)) {
      return progress || 0;
    }
  }

  return 0;
}

export const NE_TYPES = ['n257-wh-su', 'n257-hbf-su', 'n258-wh-su', 'n258-hbf-su', 'n260-wh-su', 'n260-hbf-su'];

export const DELETE_TOOLTIP = 'Can’t delete a sector in service. Please put sector out of service before deleting';

export const DEFAULT_TABLE_DATA = [
  { id: 1, device: '', neType: '', operationalState: 'Enable', baseline: 'Not Detected' },
  { id: 2, device: '', neType: '', operationalState: 'Enable', baseline: 'Not Detected' },
  { id: 3, device: '', neType: '', operationalState: 'Enable', baseline: 'Not Detected' },
  { id: 4, device: '', neType: '', operationalState: 'Enable', baseline: 'Not Detected' }
];

export const formatTableData = (device) => {
  if (!device) return DEFAULT_TABLE_DATA;

  const newData = DEFAULT_TABLE_DATA.map((data, i) => {
    const su = device?.properties?.reported?.[`SU${i + 1}`];
    const commissionInfo = su?.['commission-info'];
    const provisionInfo = su?.['provision-info'];
    const rfPath = device?.properties?.reported?.[`rf-path-${i + 1}`];

    const formattedData = { ...data };

    if (commissionInfo) {
      formattedData.device =
        commissionInfo?.['detected-serial-id']?.length >= 20 ? commissionInfo['detected-serial-id'] : '';
      formattedData.neType = NE_TYPES.includes(commissionInfo?.['detected-ne-type'])
        ? commissionInfo['detected-ne-type']
        : '';
    } else {
      formattedData.device =
        provisionInfo?.['expected-serial-id']?.length >= 20 ? provisionInfo['expected-serial-id'] : '';
      formattedData.neType = NE_TYPES.includes(provisionInfo?.['expected-ne-type'])
        ? provisionInfo['expected-ne-type']
        : '';
    }

    formattedData.operationalState = rfPath?.['service-info']?.['operational-state'] || 'Unknown';

    const updateStatusCode = su?.['baselining-status']?.['update-status-code'];
    formattedData.baseline =
      updateStatusCode === null || updateStatusCode === undefined
        ? ''
        : typeof updateStatusCode === 'number' && updateStatusCode >= 11
        ? BASELINE_UPDATE_STATUS_CODE['11']
        : typeof updateStatusCode === 'string' && updateStatusCode === 'baselineError'
        ? BASELINE_UPDATE_STATUS_LABELS.baselineError
        : typeof updateStatusCode === 'number'
        ? BASELINE_UPDATE_STATUS_CODE[updateStatusCode]
        : BASELINE_UPDATE_STATUS_LABELS[updateStatusCode] || '';
    return formattedData;
  });

  return newData;
};

export const enableCommissionActionForGa2 = (device) => {
  if (!device) return false;

  const hasCriticalAlarm = device?.tags?.['fm-alarms']?.critical;
  if (hasCriticalAlarm) return false;

  const reported = device?.properties?.reported;
  const allSUs = reported && Object.entries(reported).filter(([key, value]) => key.includes('SU'));

  for (let su of allSUs) {
    const expectedSerialId = su?.['provision-info']?.['expected-serial-id'];
    const detectedSerialId = su?.['provision-info']?.['detected-serial-id'];
    const expectedNeType = su?.['provision-info']?.['expected-ne-type'];
    const detectedNeType = su?.['provision-info']?.['detected-ne-type'];
    const baselineStatus = su?.['baselining-status']?.['update-status-code'];

    if (
      expectedSerialId?.length >= 20 &&
      detectedSerialId?.length >= 20 &&
      expectedSerialId === detectedSerialId &&
      NE_TYPES.includes(expectedNeType) &&
      NE_TYPES.includes(detectedNeType) &&
      expectedNeType === detectedNeType &&
      (baselineStatus === 10 || baselineStatus === 'atBaseline')
    ) {
      continue;
    } else {
      return false;
    }
  }

  return true;
};

export const hasSpecialCharactersAndSpaces = (str) => {
  const regex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?\s]/;

  return regex.test(str);
};
